// Normalize a stored "call me when" value. The AI (and some users) sometimes write the
// phrase "Call me when" into the value itself, which then renders twice ("Call me when
// Call me when …"). This strips any leading "Call me when" prefix(es) — case-insensitive,
// with or without a trailing colon — so the label is shown exactly once by the caller.
export const stripCallMeWhen = (s?: string | null): string =>
    (s || '').replace(/^(\s*call me when\b[:\s]*)+/i, '').trim();
